"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackWebsiteInsideFrame = void 0;
var react_1 = require("react");
var useTrackWebsiteInsideFrame = function () {
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    var _b = (0, react_1.useState)(false), pageInIframe = _b[0], setPageInIframe = _b[1];
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    (0, react_1.useEffect)(function () {
        if (mounted) {
            if (window.self !== window.top)
                setPageInIframe(true);
            else
                setPageInIframe(false);
        }
    }, [mounted]);
    return (0, react_1.useMemo)(function () { return pageInIframe; }, [pageInIframe]);
};
exports.useTrackWebsiteInsideFrame = useTrackWebsiteInsideFrame;
